// const BASE_URL = "https://admin.delta88.app/apis/";
// const BASE_URL_ = "https://admin.delta88.app/api/";
// const BASE_URL_IMAGES = "https://admin.delta88.app/Images/";
// const BASE_URL = "http://54.183.127.15/apis/";
// const BASE_URL_ = "http://54.183.127.15/api/";
// const BASE_URL_IMAGES = "http://54.183.127.15/Images/";

const BASE_URL = "https://shop.privatestockvending.com/apis/apis/";
const BASE_URL_ = "https://shop.privatestockvending.com/apis/api/";
const BASE_URL_IMAGES = "https://shop.privatestockvending.com/apis/Images/";

// const BASE_URL = "https://shop.winecountryvip.com/apis/apis/";
// const BASE_URL_ = "https://shop.winecountryvip.com/apis/api/";
// const BASE_URL_IMAGES = "https://shop.winecountryvip.com/apis/Images/";

// const CLIENT_BASE_URL = "";
const ApiConfig = {
    BASE_URL_IMAGES,
    BASE_URL, // CLIENT_BASE_URL,
    LOGIN: BASE_URL + "login", // TRANSACTION LOG
    TRANSACTION_LOG_LIST: BASE_URL + "Transactions?orderid=",
    TRANSACTION_ORDER_ID_LIST: BASE_URL + "GetOrderId",

    // =============================== ADMIN MODULE ======================================
    GET_ADMIN_LIST: BASE_URL + "AdminList",
    Add_ADMIN_DATA: BASE_URL + "adduseradmin",
    GET_ADMIN_DATA_BY_ADMIN_ID: BASE_URL + "getuserbyidadmin",
    UPDATE_ADMIN_DATA: BASE_URL + "edituseradmin",
    DELETE_ADMIN_DATA: BASE_URL + "deleteuserbyadmin", // =============================== ADMIN MODULE ======================================

    // =============================== VENDING MODULE ======================================
    // getallvendingmachine
    // GET_ALL_VENDING_MACHINE: BASE_URL + "getallvendingmachine",
    GET_ALL_VENDING_MACHINE: BASE_URL + "VendingMachineName",
    GET_EDIT_DATA_BY_ID: BASE_URL + "getvendingmachinebyid",
    UPDATE_VENDING_MACHINE_DATA: BASE_URL + "update_vending_machine",
    ADD_VENDING_MACHINE: BASE_URL + "create_vending_machine",
    DELETE_VENDING_MACHINE: BASE_URL + "deletevendingmachine",
    CLEAR_VENDING_MACHINE_DATA: BASE_URL + "Updateallrecord", // =============================== VENDING MODULE ======================================
    // USER MODULE

    USER_LIST: BASE_URL_ + "User/getusers",
    VIEW_USER_DETAILS: BASE_URL_ + "User/getusersbyid?id=",
    FIND_USER_DETAILS: BASE_URL + "getuserbyidadmin?id=",
    DELETE_USER: BASE_URL_ + "User/deleteuserbyid?id=",

    // ORDER MODULE

    ORDER_LIST: BASE_URL + "GetOrderList?Month=",
    ORDER_DETAILS_BY_ID: BASE_URL + "GetOrderDetails",
    ORDER_ID_LIST: BASE_URL + "GetOrderId",
    UPDATE_ORDER_STATUS: BASE_URL + "update_order_status",

    // CATEGORY MODULE
    ADD_CATEGORY: BASE_URL + "addcategory",
    CATEGORIES: BASE_URL + "categories",
    UPDATE_CATEGORY: BASE_URL + "updatecategory",
    DELETE_CATEGORY: BASE_URL + "deletecategory",

    // COUPON MODULE
    GET_ALL_COUPON: BASE_URL + "getallcoupon",
    GET_COUPON_BY_CODE: BASE_URL + "getcouponbycode?code=",
    ADD_COUPON: BASE_URL + "addcoupon",
    UPDATE_COUPON: BASE_URL + "updatecoupon",
    DELETE_COUPON: BASE_URL + "deletecoupon?id=",

    // PRODUCT MODULE
    PRODUCTS: BASE_URL + "products?page=",
    GET_PRODUCT: BASE_URL + "products",
    ADD_PRODUCT: BASE_URL + "AddProduct",
    EDIT_PRODUCT: BASE_URL + "UpdateProduct",

    // PRODUCT REVIEW
    GET_PRODUCT_REVIEW_BY_ID: BASE_URL + "product-review/get-product-reviews-admin?productId=",
    DELETE_PRODUCT_REVIEW_BY_ID: BASE_URL + "product-review/delete-review-admin?reviewID=",
    GET_PRODUCT_REVIEWS: BASE_URL + "product-review/get-all-reviews-admin",
    APPROVE_REVIEW_STATUS: BASE_URL + "product-review/approve-review-admin",

    // Stock Statement

    STOCK_TRANSACTION_LIST: BASE_URL + "TransactionDate",

    // CompanyInfo
    GET_TERMS_AND_CONDITION: BASE_URL_ + "CompanyInfo/termsandconditions",
    UPDATE_TERMS_AND_CONDITION: BASE_URL_ + "CompanyInfo/updatetermsandconditions",

    // Privacy policy
    GET_PRIVACY_POLICY: BASE_URL_ + "CompanyInfo/privacypolicy",
    UPDATE_PRIVACY_POLICY: BASE_URL_ + "CompanyInfo/updateprivacypolicy",

    // About us
    GET_ABOUT_US: BASE_URL_ + "CompanyInfo/aboutus",
    UPDATE_ABOUT_US: BASE_URL_ + "CompanyInfo/updateaboutus",

    // Transaction history
    GET_ALL_TRANSACTION_LIST: BASE_URL_ + "TransactionHistory/getalltransactionhistory", // Dashboard
    GET_ALL_COUNTS_DASH: BASE_URL_ + "Dashboard/getdashboardcount",

    // View all products
    VIEW_SINGLE_PRODUCT_ID: BASE_URL + "viewproduct",
    DELETE_PRODUCT: BASE_URL + "deleteproduct",
    DELETE_PRODUCT_IMG: BASE_URL + "deleteimage",
    DELETE_PRODUCT_SUPP_IMG: BASE_URL + "del-prod-supp-img",

    // Delete order by id
    DELETE_ORDER_BY_ID: BASE_URL + "DeleteById", // Age Verification
    AGE_VERIFICATION: "http://54.183.127.15/apis/getAccessToken",
    AGE_VERIFICATION_POST: "http://54.183.127.15/apis/hvfacedetectweb",
    PAYMENT_GETWAY: "http://54.183.127.15/apis/ordrplacebywebpaymenturl",
    GET_PICKUP_CODE: "http://54.183.127.15/apis/WebDispense/",
    TRANSCTION_LOG: "http://54.183.127.15/apis/getispaymentweb?orderid=",

    // Slot

    GET_MACHINE_SLOT: BASE_URL + "GetMachineSlots/", // pass Id
    UPDATE_SLOT_DATA: BASE_URL + "UpdateSlotData",
    UPDATE_PRODUCT_INTO_MACHINE: BASE_URL + "update_product_into_machine",
    GET_SLOT_DATA: BASE_URL + "GetSlotData",
    GET_VM_SLOT_INFO: BASE_URL + "get_vm_slots_info",

    // INVENTORY LOG MODULE
    GET_INVENTORY_ID: BASE_URL + "GetInventoryId/",
    GET_SLOTS: BASE_URL + "GetSlots/",
    GET_INVENTORY_LOG_BY_ID: BASE_URL + "GetInventoryLog", // pass Id
};

export default ApiConfig;
